<!--
 * @Author: zhaoliang
 * @Date: 2024-07-04 14:51:47
 * @LastEditTime: 2026-03-27 10:56:51
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Membership/component/Member/PDFModal.vue
 *
-->

<template>
  <div class="modal-mask" v-if="open" ref="modalMask">
    <div class="modal-containner">
      <img
        class="modal-close"
        @click="handleVisable(false)"
        src="~img/cancel.png"
        alt="cancel"
        role="button"
        aria-label="close"
      />
      <div class="modal-content">
        <p class="description">
          {{ $t('mbs-email-view') }}
        </p>
        <div class="pdf-wrap">
          <div class="pdf">
            <!-- <pdf ref="pdf" :src="url"></pdf> -->
            <pdf ref="pdf" :pdfUrl="pdfUrl"></pdf>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="modal-print-btn" @click="handlePrint">{{ $t('mbs-email-print') }}</button>
        <button class="modal-download-btn" @click="handleDownload" @touchend="handleDownload">
          {{ $t('mbs-email-download') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import pdf from '@/components/PDFViewer/index.vue';
  export default {
    name: 'Modal',
    components: {
      pdf,
    },
    computed: {},
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      pdfUrl: {
        type: Blob,
        default: new Blob(),
      },
    },
    data() {
      return {
        url: {},
        downloadPdfUrl: {},
      };
    },
    created() {},
    mounted() {},
    methods: {
      handleVisable(visable) {
        this.$emit('update:open', visable);
      },
      // 转为PDF
      getObjectURL(file) {
        let url = null;
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          try {
            url = window.webkitURL.createObjectURL(file);
          } catch (error) {
            console.error(error);
          }
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          try {
            url = window.URL.createObjectURL(file);
          } catch (error) {
            console.error(error);
          }
        }
        return url;
      },
      // 打印PDF
      handlePrint() {
        // this.$refs.pdf.print();
        this.$refs.pdf.printPDF();
      },
      // 下载PDF
      handleDownload() {
        if (this.isShowPDFDownloadProgress) return;
        this.isShowPDFDownloadProgress = true;
        const blob = new Blob([this.downloadPdfUrl], {
          type: 'application/pdf',
        });
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.download = 'Membership Details';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          this.isShowPDFDownloadProgress = false;
        }, 3000);
      },
    },
    watch: {
      // open(val) {
      //   if (val) {
      //     this.$nextTick(() => {
      //       document.body.appendChild(this.$refs.modalMask);
      //     });
      //   } else {
      //     document.body.removeChild(this.$refs.modalMask);
      //   }
      // },
      pdfUrl: {
        handler(newval) {
          this.url = this.getObjectURL(newval);
          this.downloadPdfUrl = newval;
        },
      },
      open: {
        handler(val) {
          if (!val) {
            this.$refs.pdf.destroyPDF();
          }
        },
      },
    },
  };
</script>
<style lang="scss" scoped>
  .modal-mask {
    @include wh(100%, 100%);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    background-color: rgba(22, 48, 73, 0.94);

    .modal-containner {
      position: fixed;
      top: 15%;
      left: 50%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 48.5vw;
      padding: 50px 72px 38px;
      background: #fff;
      border-radius: 10px;
      transform: translateX(-50%);

      .modal-close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }

      .modal-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        @include font($size: 18px, $weight: 400);
        text-align: center;
        line-height: 28px;
        color: #01194d;
        flex-direction: column;

        .description {
          margin-bottom: 30px;
        }

        .pdf-wrap {
          width: 80%;
          max-height: 50vh;
          overflow: auto;

          .pdf {
            min-height: 600px;
            margin-right: 32px;
            background: #fff;
            border: 1px solid #163049;
          }

          @include scroll-bar(8px);
        }
      }

      .modal-footer {
        margin-top: 24px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .modal-print-btn {
          cursor: pointer;
          width: 40%;
          height: 48px;
          background-color: #fff;
          border: 2px solid #c29d5c;
          color: #c29d5c;
          @include font($size: 18px, $weight: 600);
          border-radius: 5px;
        }
        .modal-download-btn {
          cursor: pointer;
          width: 40%;
          height: 48px;
          background-color: #c29d5c;
          color: #ffffff;
          @include font($size: 18px, $weight: 600);
          border-radius: 5px;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .modal-mask {
      .modal-containner {
        width: 90%;
        padding: 30px 20px 30px;
        top: 10%;

        .modal-close {
          top: 12px;
          right: 12px;
          width: 12px;
          height: 12px;
        }

        .modal-content {
          @include font($size: 12px, $weight: 400);
          line-height: 22px;

          .description {
            margin-bottom: 15px;
          }

          .pdf-wrap {
            width: 100%;
            max-height: 50vh;
            overflow: auto;

            .pdf {
              min-height: unset;
              margin-right: 10px;
              background: #fff;
              border: 1px solid #163049;
            }

            @include scroll-bar(5px);
          }
        }

        .modal-footer {
          margin-top: 18px;

          .modal-print-btn {
            width: 45%;
            height: 32px;
            @include font($size: 12px, $weight: 600);
          }
          .modal-download-btn {
            width: 45%;
            height: 32px;
            @include font($size: 12px, $weight: 600);
          }
        }
      }
    }
  }
</style>
